import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMyFeatureFlags, getPublicFeatureFlags } from '../utils/api';
import { useAuth } from './AuthContext';

const FeatureFlagsContext = createContext();

export const useFeatureFlags = () => {
    const context = useContext(FeatureFlagsContext);
    if (!context) {
        throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
    }
    return context;
};

export const FeatureFlagsProvider = ({ children }) => {
    const { isAuthenticated, loading: authLoading } = useAuth();
    const [flags, setFlags] = useState({
        leaderboard: false,
        learn: false,
        community: false,
        blog: false,
        ai_coach: false,
        ats: false,
        jobs: false
    });
    const [loading, setLoading] = useState(true);

    const fetchFlags = async () => {
        try {
            let data;
            if (isAuthenticated) {
                data = await getMyFeatureFlags();
            } else {
                data = await getPublicFeatureFlags();
            }
            // Data is a map of key -> boolean
            if (data) {
                setFlags(prev => ({ ...prev, ...data }));
            }
        } catch (error) {
            console.error('Failed to fetch feature flags:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!authLoading) {
            fetchFlags();
        }
    }, [isAuthenticated, authLoading]);

    const isEnabled = (key) => {
        if (loading) return !!flags[key]; // Return default while loading 
        return !!flags?.[key];
    };

    return (
        <FeatureFlagsContext.Provider value={{ flags, isEnabled, loading, refreshFlags: fetchFlags }}>
            {children}
        </FeatureFlagsContext.Provider>
    );
};
